module.exports = __webpack_public_path__ + "static/media/hex_polygon.2aa0ae6b.svg";